import React from 'react';
import PageTemplate from '../../components/Common/PageTemplate';
import { motion } from 'framer-motion';
import { FaUniversity } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

const ScholarshipCommission = () => {
  const { t } = useTranslation();

  const committeeMembers = [
    {
      title: 'Prof. Dr.',
      name: 'Hatice Mergen',
      role: t('dean.title'),
      imageUrl: 'https://avesis.hacettepe.edu.tr/user/image/5582',
    },
    {
      title: 'Prof. Dr.',
      name: 'Canan Köroğlu',
      role: t('vice_deans.vice_dean'),
      imageUrl: 'https://avesis.hacettepe.edu.tr/user/image/6842',
    },
    {
      title: 'Prof. Dr.',
      name: 'Barış Temelli',
      role: t('vice_deans.vice_dean'),
      imageUrl: 'https://avesis.hacettepe.edu.tr/user/image/5902',
    },
    {
      title: 'Dr. Öğr. Üyesi',
      name: 'Aslıhan Şentürk Acar',
      role: t('departments.actuarial_science'),
      imageUrl: 'https://avesis.hacettepe.edu.tr/user/image/7744',
    },
    {
      title: 'Doç. Dr.',
      name: 'Aslı Koca',
      role: t('departments.biology'),
      imageUrl: 'https://avesis.hacettepe.edu.tr/user/image/7082',
    },
    {
      title: 'Prof. Dr.',
      name: 'Semra Türkan',
      role: t('departments.statistics'),
      imageUrl: 'https://avesis.hacettepe.edu.tr/user/image/6992',
    },
    {
      title: 'Prof. Dr.',
      name: 'Handan Yavuz Alagöz',
      role: t('departments.chemistry'),
      imageUrl: 'https://avesis.hacettepe.edu.tr/user/image/7654',
    },
    {
      title: 'Doç. Dr.',
      name: 'Seçil Tokgöz',
      role: t('departments.mathematics'),
      imageUrl: 'https://avesis.hacettepe.edu.tr/user/image/6011',
    },
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
      },
    },
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        type: 'spring',
        stiffness: 100,
      },
    },
  };

  return (
    <PageTemplate
      title={t('scholarship_commission.title')}
      subtitle={t('scholarship_commission.subtitle')}
    >
      <div className="container mx-auto px-4 py-8">
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center bg-white p-8 rounded-2xl shadow-lg mb-12 border border-gray-100"
        >
          <h2 className="text-3xl font-bold text-gray-800 mb-4">
            {t('scholarship_commission.mission_title')}
          </h2>
          <p className="text-lg text-gray-600 max-w-4xl mx-auto leading-relaxed">
            {t('scholarship_commission.mission_description')}
          </p>
        </motion.div>

        <motion.div
          variants={containerVariants}
          initial="hidden"
          animate="visible"
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-10"
        >
          {committeeMembers.map((member, index) => (
            <motion.div
              key={index}
              variants={itemVariants}
              whileHover={{ scale: 1.05, y: -8 }}
              className="bg-white rounded-2xl shadow-lg text-center p-6 transition-all duration-300 ease-in-out border-t-4 border-teal-500"
            >
              <div className="mb-4">
                <img
                  src={member.imageUrl}
                  alt={member.name}
                  className="w-32 h-32 rounded-full mx-auto object-cover border-4 border-white shadow-md"
                  onError={(e) => {
                    e.target.src = `https://ui-avatars.com/api/?name=${member.name.replace(' ', '+')}&background=0D9488&color=fff&size=128&bold=true&rounded=true`;
                  }}
                />
              </div>
              <h3 className="text-xl font-bold text-gray-800">{member.name}</h3>
              <p className="text-md text-gray-500 mb-3">{member.title}</p>
              <div className="flex items-center justify-center text-gray-700 bg-gray-50 px-4 py-2 rounded-lg">
                <FaUniversity className="mr-2 text-teal-600" />
                <span className="font-medium text-sm">{member.role}</span>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </PageTemplate>
  );
};

export default ScholarshipCommission;